/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Related_ArticlesInputs */

const en_related_articles = /** @type {(inputs: Related_ArticlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related articles: `)
};

const nl_related_articles = /** @type {(inputs: Related_ArticlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerelateerde artikelen: `)
};

/**
* | output |
* | --- |
* | "Related articles:" |
*
* @param {Related_ArticlesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const related_articles = /** @type {((inputs?: Related_ArticlesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Related_ArticlesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_related_articles(inputs)
	return en_related_articles(inputs)
});